import { render, staticRenderFns } from "./_dialogs.vue?vue&type=template&id=fc857542&scoped=true&lang=pug&"
import script from "./_dialogs.vue?vue&type=script&lang=js&"
export * from "./_dialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc857542",
  null
  
)

export default component.exports